var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paymark-Apps-Copy-2",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 6 6 6 6 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "20 6 26 6 26 0 20 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "10 6 16 6 16 0 10 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "0 16 6 16 6 10 0 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "20 16 26 16 26 10 20 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "10 16 16 16 16 10 10 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "0 26 6 26 6 20.001 0 20.001"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "20 26 26 26 26 20.001 20 20.001"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    points: "10 26 16 26 16 20.001 10 20.001"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchColor);
export default __webpack_public_path__ + "static/media/switch-color.679939bca416aef338ac9022e6d65db1.svg";
export { ForwardRef as ReactComponent };